"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoAIPromptRecord = exports.autoAIPromptStore = void 0;
exports.initAutoAIPromptDb = initAutoAIPromptDb;
exports.getAutoAIPrompts = getAutoAIPrompts;
exports.saveAutoAIPrompt = saveAutoAIPrompt;
exports.updateAutoAIPrompt = updateAutoAIPrompt;
exports.deleteAutoAIPrompt = deleteAutoAIPrompt;
const IndexedDBStorage_1 = require("./IndexedDBStorage");
exports.autoAIPromptStore = "AutoAIPromptStore";
class AutoAIPromptRecord {
    data;
    constructor(d) {
        this.data = d;
    }
    getStoreName() {
        return exports.autoAIPromptStore;
    }
    getKey() {
        return this.data.id;
    }
    toJSON() {
        return this.data;
    }
}
exports.AutoAIPromptRecord = AutoAIPromptRecord;
async function initAutoAIPromptDb() {
    const db = new IndexedDBStorage_1.IndexedDBStorage(exports.autoAIPromptStore);
    await db.init(exports.autoAIPromptStore);
    await db.createIndex(exports.autoAIPromptStore, {
        name: "userBranch",
        keyPath: ["userId", "branchId"],
    });
}
// load all prompts for a given user and branch
async function getAutoAIPrompts(userId, branchId) {
    await initAutoAIPromptDb();
    const db = new IndexedDBStorage_1.IndexedDBStorage(exports.autoAIPromptStore);
    const results = await db.getAllFromIndexInRange(exports.autoAIPromptStore, "userBranch", [userId, branchId], [userId, branchId]);
    const prompts = results
        .map(r => ({ id: r.id, date: r.date, message: r.message }))
        .sort((a, b) => b.date.localeCompare(a.date));
    return prompts;
}
// save a new prompt for a given user and branch
async function saveAutoAIPrompt(userId, branchId, message) {
    await initAutoAIPromptDb();
    const db = new IndexedDBStorage_1.IndexedDBStorage(exports.autoAIPromptStore);
    const record = {
        id: `${userId}-${branchId}-${new Date().valueOf()}`,
        userId,
        branchId,
        date: new Date().toISOString(),
        message,
    };
    await db.put(new AutoAIPromptRecord(record));
    return record;
}
async function updateAutoAIPrompt(prompt, userId, branchId) {
    await initAutoAIPromptDb();
    const db = new IndexedDBStorage_1.IndexedDBStorage(exports.autoAIPromptStore);
    const updated = {
        id: prompt.id,
        message: prompt.message,
        date: new Date().toISOString(),
        userId,
        branchId,
    };
    await db.put(new AutoAIPromptRecord(updated));
    return updated;
}
async function deleteAutoAIPrompt(prompt, userId, branchId) {
    await initAutoAIPromptDb();
    const db = new IndexedDBStorage_1.IndexedDBStorage(exports.autoAIPromptStore);
    const record = {
        id: prompt.id,
        userId,
        branchId,
        date: prompt.date,
        message: prompt.message,
    };
    await db.delete(new AutoAIPromptRecord(record));
}
